import React, {useEffect} from "react";
import {Layout} from "@components/layout/Layout";
// import IntercomChat from '../IntercomChat';
export const Support = () => {
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > window.innerHeight / 3) {
        document.body.classList.add("show-scroll-btn");
      } else {
        document.body.classList.remove("show-scroll-btn");
      }
    };
    const handleClick = () => {
      document.body.classList.toggle("hidden");
      document.documentElement.classList.toggle("hidden");
    };

    // Bind events
    const checkMenu = document.getElementById("check-menu");
    if (checkMenu) {
      checkMenu.addEventListener("click", handleClick);
    }

    window.addEventListener("scroll", handleScroll);

    return () => {
      if (checkMenu) {
        checkMenu.removeEventListener("click", handleClick);
      }
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // const handleSignUpToggle = (isOpen) => {
  //   dispatch(toggleSignUpModal(isOpen));
  // };

  useEffect(() => {
    document.body.classList.add('main-page');
    return () => {
      document.body.classList?.remove('main-page');
    };
  }, []);

  return (<Layout>
    <div className="basic-main">
      <div className="container">
        <div className="support-header-section section">
          <div className="support-title">
            <h1>Support</h1>
            <p>Need help? We're here for you 24/7. Reach out to us via chat, email or phone hotline, and the Cronika
              client support team will be glad to assist you.</p>
          </div>
          <figure className="support-img"><img src={require("@assets/images/main/support-img.jpg")} alt="img"/></figure>
          <div className="support-contacts">
            <div className="box">
              <figure className="contact-icon"><img src={require("@assets/images/main/chat-icon-black.svg").default}
                                                    alt="icon"/></figure>
              <span className="contact-title">Chat online</span>
			<a
			  className="basic-button small-size"
			  onClick={(e) => {
			    e.preventDefault();
			    window.openIntercomChat?.(); 
			  }}
			>
			  Start chat
			</a>
              {/* <a href="#" id="open-intercom" class="basic-button">Start chat</a> */}

            </div>
            <div className="box">
              <figure className="contact-icon"><img src={require("@assets/images/main/email-icon-black.svg").default}
                                                    alt="icon"/></figure>
              <span className="contact-title">Email</span><a href="mailto:support@cronika.com">support@cronika.com</a>
              <p>Ask a question and we'll respond within one business day</p>
            </div>
          </div>
        </div>
        <div className="support-faq-section section">
          <div className="support-faq-title">
            <h2>FAQ</h2>
            <p>If you couldn't find an answer to your question, our 24/7 support team will be happy to help you.</p>
          </div>
          <div className="support-faq">
            <div className="faq-item open-close"><span
              className="question open-close-btn">How do I start trading?</span>
              <div className="answer open-close-drop">
                <p>Register on the platform, make a minimum deposit of $10, choose an asset you want to trade, specify the trade volume and other details if required, and confirm the transaction.</p>
              </div>
            </div>
            <div className="faq-item open-close"><span className="question open-close-btn">What is the minimum deposit amount?</span>
              <div className="answer open-close-drop">
                <p>The minimum deposit amount is $10.
                </p>
              </div>
            </div>
            <div className="faq-item open-close"><span className="question open-close-btn">What is the minimum withdrawal amount?</span>
              <div className="answer open-close-drop">
                <p>The minimum withdrawal amount is $10.</p>
              </div>
            </div>
            <div className="faq-item open-close"><span
              className="question open-close-btn">How do I make a deposit?</span>
              <div className="answer open-close-drop">
                <p>To make a deposit, you need to choose the Deposit section on your trading terminal, choose the payment method, fill in the deposit amount, and click the Deposit button. 
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    {/* <IntercomChat /> */}
  </Layout>);
};
// const openIntercom = (e) => {
//   e.preventDefault();
//   if (window.Intercom) {
//     window.Intercom('show');
//   }
// };
export default Support;
